import { render } from "./NotFound.vue?vue&type=template&id=1c46daaa"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=1c46daaa&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__